import React from "react"
import Navbar from "./Navbar"
import Sidebar from "./Sidebar"
import Footer from "./Footer"
import TopHero from "./TopHero"
import TopHeroModal from "./TopHeroModal"
import { ModalRoutingContext } from 'gatsby-plugin-modal-routing'

const Layout = ({ title, subtitle, home, children, footerTop=true }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }
  return (
    <ModalRoutingContext.Consumer>
      {({ modal, closeTo }) => (
        <>
          {modal ? (
            <>
            <Navbar toggleSidebar={toggleSidebar} modal={modal} closeTo={closeTo}>
                <TopHeroModal title={title} subtitle={subtitle} home="modal" />
              </Navbar>
            {children}
            </>
          ) : (
            <>
              <Navbar toggleSidebar={toggleSidebar} isOpen={isOpen}>
                <TopHero title={title} subtitle={subtitle} home={home} />
              </Navbar>

              <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
              {children}
              <Footer footerTop={footerTop}/>
            </>
          )}
        </>
      )}
    </ModalRoutingContext.Consumer>
  )
}

export default Layout
